import { render, staticRenderFns } from "./UXMediaPublished.vue?vue&type=template&id=528dba68&scoped=true"
import script from "./UXMediaPublished.vue?vue&type=script&lang=js"
export * from "./UXMediaPublished.vue?vue&type=script&lang=js"
import style0 from "./UXMediaPublished.vue?vue&type=style&index=0&id=528dba68&prod&lang=sass&scoped=true"
import style1 from "./UXMediaPublished.vue?vue&type=style&index=1&id=528dba68&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528dba68",
  null
  
)

export default component.exports